import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";
import { VenturesApiResponse, VentureResponse } from "../types/ventures-types";

export const fetchVentures = createAsyncThunk(
  "ventures/fetchVentures",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get<VenturesApiResponse>(
        "/ventures?populate=*"
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

type VenturesState = {
  ventures: VentureResponse[];
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
};

const initialState: VenturesState = {
  ventures: [],
  status: "idle",
  error: null,
};

const venturesSlice = createSlice({
  name: "ventures",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchVentures.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchVentures.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.ventures = action.payload.data;
      })
      .addCase(fetchVentures.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload as string;
      });
  },
});

export default venturesSlice.reducer;
